import { gql } from '@apollo/client';

export const DECISION_FLOW_FIELDS_FRAGMENT = gql`
  fragment DecisionFlowFields on DecisionFlow {
    id
    brand
    tree
    tag
    isActive
    simplrAccountId
  }
`;
